// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"LocalesList_pageHeader__3tGTq"};